import {createCookie} from "./create-cookie.ts";
import {formatFlagsCookie} from "./format-flags-cookie.ts";
import {parseFlagsCookie} from "./parse-flags-cookie.ts";
import {readCookie} from "./read-cookie.ts";
import {CookieCategory} from "./types.ts";

/**
 * Set a specific feature flag in the flags cookie.
 *
 * @param name - The name of the feature flag to set the status for.
 * @param pass - The status to set for the flag. If true, the flag will be set
 * to on. If this is false, the flag will be set to off.
 * If this is null, the flag will be removed from the cookies.
 */
export function setFeatureOverride(name: string, pass?: boolean | null): void {
    const cookie = readCookie("flags") || "";
    const passes = parseFlagsCookie(cookie);
    if (pass == null) {
        delete passes[name];
    } else {
        passes[name] = pass;
    }
    const newCookie = formatFlagsCookie(passes);
    createCookie("flags", CookieCategory.Functional, newCookie);
}
